export const Countries = {
	Finland: "Finland",
	Netherlands: "Netherlands",
	Sweden: "Sweden",
	Norway: "Norway",
	Poland: "Poland",
	Denmark: "Denmark",
	German: "German",
};
